<template>
  <div v-if="journal" >
      <app-pattern-journal :bo="bo" :key="getRandomInt(10)"></app-pattern-journal>
      <app-footer-journal></app-footer-journal>
  </div>
</template>
<script>
import patternJournal from './pattern/PatternJournal.vue';
import footerJournal from './FooterJournal.vue';

import {mapActions, mapGetters} from 'vuex';

export default {
    name:"journal",
    props:{
        bo: {
            type:Boolean,
            default:false
        },
        journal_id:{
            type:Number,
            default:0,
        }
    },
    metaInfo() {
        return{
            title: "Journals IM",
            meta: [
                {vmid: "keywords", name: "keywords",content:  "Instructions for authors, Hybrid publishing model, Current issue"},
                {vmid: "description", name: "description",content:"Journal publishes original research papers of high scientific quality in mathematics"}

            ]
        }
    },
    data(){
        return {
            id_journal:0,
            tag_to_component : {
                home : "AppHomeJournal",
                editorial : "AppEditorialBoard",
                instructions : "AppInstructions",
                hybrid : "AppHybridModel",
                sub : "AppSubscription",
                online : "AppOnLineArticle",
                current : "AppCurrentIssue",
                all : "AppAllIssue",
            }
        };
    },
    created(){
        if(this.journal_id >0 ){
            this.$route.params.journal_id = this.journal_id;
        }
        if(this.$route.params.tab) {
            this.switchComponents();
        } else {
            this.setCurrentTabComponent('AppHomeJournal');
        }
        this.setBismenudown(this.width > 500);  
        this.setJournal(this.$route.params.journal_id) ;
        this.setJournalBis(this.$route.params.journal_id) ;
        this.setDescription(this.$route.params.journal_id);      
  },
  updated() {
    // If the tab has changed, do the necessary updates. 
    if (this.currentTabComponent && this.$route.params.tab) {
        if (this.component_to_tag[this.currentTabComponent] != this.$route.params.tab) {
            this.switchComponents(); 
        }
    } else {
        this.setCurrentTabComponent('AppHomeJournal');
    }
  },
  components:{
      appPatternJournal:patternJournal,
      appFooterJournal:footerJournal,
  },
    computed:{
        ...mapGetters('library',{
            journal:'journal',
            currentTabComponent:'currentTabComponent',
        }),
        ...mapGetters('header',{
            width:'width',
        }),
        component_to_tag : function() {
            return Object.fromEntries(
                Object
                    .entries(this.tag_to_component)
                    .map(([key, value]) => [value, key])
                );
        }
    },
  methods:{
        ...mapActions('library',{
            setJournal:'setJournal',
            setJournalBis:'setJournalBis',
            setDescription:'setDescription',
            setCurrentTabComponent:'setCurrentTabComponent',
            setBismenudown:'setBismenudown',
            setShowOneIssue:'setShowOneIssue',
        }),
        getRandomInt(max) {
            return Math.floor(Math.random() * max);
        },
        switchComponents () {
            this.setCurrentTabComponent(this.tag_to_component[this.$route.params.tab]);
            this.setBismenudown(this.width > 500);
            if (this.tag_to_component[this.$route.params.tab] == 'AppAllIssue') {
                this.setShowOneIssue(false);
            }
        }
    },
}
</script>
